import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { ComponentBase } from "../base/component-base";
import { ApplicantService } from "../service/applicant.service";
import { BehaviorModelChangeService } from "../service/behavior-model-change.service.service";
import { CookiesLocalService } from "../service/cookies-local.service";
import { DialogService } from "../service/dialog-service";
import { UtilService } from "../service/util.service";

@Component({
  selector: "app-document-upload",
  templateUrl: "./document-upload.component.html",
  styleUrls: ["./document-upload.component.scss"],
})
export class DocumentUploadComponent extends ComponentBase implements OnInit {
  docs: any[];
  constructor(
    applicantService: ApplicantService,
    cookieLocal: CookiesLocalService,
    private router: Router,
    private utilService: UtilService,
    private toastr: ToastrService,
    private dialogService: DialogService,
    behaviorModelChangeService: BehaviorModelChangeService
  ) {
    super(applicantService, cookieLocal, behaviorModelChangeService);
  }

  ngOnInit() {
    this.loadData();
  }

  private loadData() {
    this.applicantService
      .getApplicantDocuments(this.applicantData.ApplicationId)
      .subscribe((data) => {
        this.docs = data;
      });
  }

  onAddOrEditDocument(data: any) {
    this.dialogService
      .openAddEditDocumentComponentDialog(data, data === null)
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.loadData();
        }
      });
  }

  onDelete(data: any) {
    this.applicantService
      .removeApplicantDocument(data.ApplicationDocumentId)
      .subscribe((data) => {
        this.loadData();
      });
  }
}
